module.exports = __webpack_public_path__ + "img/icon-promo-black.a7445379.svg";